import React from 'react';
import classnames from 'classnames';
import {ReactSVG} from "react-svg";
import {formatDateMDY, getBackgroundImg, getPublicImagePath, getUploadedImagePath} from "@nutastic/nutastic-react-app";

const getHeaderClass = type => {
    switch ((type || 0).toString()) {
        case '1': return 'left-layout'
        case '2': return 'right-layout'
        case '3': return 'article-layout'
        case '4': return 'blogCategory-layout'
        default: return 'basic-layout'
    }
};

const PageHeader = ({ addOnContent, children, className, date, image, subtext, title, type }) => {
    const componentClass = 'page-header';
    const classes = classnames(componentClass, className, `${componentClass}--${getHeaderClass(type)}`);
    const headerImgStyle = type && image ? getBackgroundImg(getUploadedImagePath(image)) : {};
    const useImage = !!(image && type);
    const useDate = date && (type || 0).toString() === '3';

    return <section className={classes}>
        <div className={ `${componentClass}__container` }>
            { useImage && <div className={`${componentClass}__img`} style={headerImgStyle} /> }
            <div className={`${componentClass}__content`}>
                <h1>{ title }</h1>
                { subtext && <p>{ subtext }</p> }
                { addOnContent && <div className={`${componentClass}__addOnContent`}>{ addOnContent }</div> }
            </div>
            { children && <div className={`${componentClass}__children`}>{ children }</div> }
            <ReactSVG src={ getPublicImagePath('down-arrow.svg') } className="down-arrow" />
            { useDate && <div className={`${componentClass}__date`}>{ formatDateMDY(date) }</div> }
        </div>
    </section>
};

export default PageHeader;
